<template>
	<div class="px-6 py-4 space-y-4 text-text-secondary">
		<slot></slot>
	</div>
</template>
